import { mockAwareFetch } from "./transport";
import type { AppNotification } from "@/stores/notificationsStore";

// Same shapes as the patient notification endpoints (see patient/api/notificationsApi.ts),
// audience PHYSICIAN only. The mark-read paths mirror the patient ones under /api/physician.

interface NotificationListResponse {
  data: AppNotification[];
  unreadCount: number;
}

export async function listPhysicianNotificationsApi() {
  const { data, error } = await mockAwareFetch<NotificationListResponse>("/api/physician/notifications", { method: "GET", portal: "physician" });
  return { data, error: error?.message ?? null };
}

export async function markPhysicianNotificationReadApi(id: string) {
  const { data, error } = await mockAwareFetch<{ message?: string }>(`/api/physician/notifications/${id}/read`, { method: "POST", portal: "physician" });
  return { data, error: error?.message ?? null };
}

export async function markAllPhysicianNotificationsReadApi() {
  const { data, error } = await mockAwareFetch<{ message?: string }>("/api/physician/notifications/read-all", { method: "POST", portal: "physician" });
  return { data, error: error?.message ?? null };
}

/** GET /api/physician/notifications/unread-count. The bell itself counts the
 *  allowlisted unread items from the list, so nothing calls this yet. */
export async function getPhysicianUnreadCountApi() {
  const { data, error } = await mockAwareFetch<{ unreadCount: number }>("/api/physician/notifications/unread-count", { method: "GET", portal: "physician" });
  return { data, error: error?.message ?? null };
}
